const EMPTY_ARRAY: unknown[] = [];

// Used to create a stable empty array that is typed
export const getEmptyArray = <T extends unknown[]>(): T => EMPTY_ARRAY as T;
